import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Checkbox.scss';
import { faCheckSquare, faSquare } from '@fortawesome/free-regular-svg-icons';

const CheckBox = props => {

    const checked = props.checked ? true : false;
    const [valueCheck, setValueCheck] = useState(checked);

    const setValue = bool => {

        setValueCheck(bool);
        if(props.callback) {
            if(props.callbackArgs !== undefined){
                props.callback(props.value, bool, props.callbackArgs);
            } else {
                props.callback(props.value, bool);
            }
        }
    }

    const isChecked = () => {
        return props.reload ? props.checked : valueCheck;
    }
    
    useEffect(()=>{
        
    },[]);
    if(props.showlog){
        console.log({ valueCheck, ischecked: isChecked(), args: props.callbackArgs, propchecked: props.checked});
    }

    return (
        <div className="checkboxButton">
            <button type="button" className={isChecked() ? 'selecionado' : ''} onClick={() => setValue(!isChecked())}>
                {props.showIcon && isChecked() && <FontAwesomeIcon icon={faCheckSquare} />}
                {props.showIcon && !isChecked() && <FontAwesomeIcon icon={faSquare} />}
                {props.label}
            </button>
        </div>
    );
};

export default CheckBox;